<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-primary(:to="{name: 'createProductMetadataSchema'}") New Product Metadata Schema
    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Id
        th Name
        th
      tr(v-for="s in schemas")
        td {{s.id}}
        td {{s.name}}
        td.actions
          router-link.btn-view(:to="{name: 'viewProductMetadataSchema', params: {name: s.name}}" title="View schema") View
          a.btn-trash(@click="deleteSchema(s.name)" title="Delete schema")
</template>

<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    errorMsg: null,
    schemas: []
  }),
  methods: {
    fetchData(page) {
      const req = page.maxOffsetRequest()

      return Core.listProductMetadataSchemas(req)
        .then((resp) => {
          this.schemas = resp.data.schema
          return resp.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    deleteSchema(name) {
      this.$confirm({ text: `Are you sure you want to delete schema ${name}` })
        .then((conf) => {
          if (conf) {
            Core.deleteProductSchema(name)
              .then(() => {
                miniToastr.success(`${name} was deleted`)
                this.$refs.grid.reload()
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/productmetadataschema/ProductMetadataSchemas.vue